import { PrimaryLinkArrow } from '../../../styles';
import {
  givingBackLinks,
  membershipLinks,
  primaryLink,
  promoCard,
} from '../../data/generosityConstants';
import { MobileMenuPromoCard } from '../components/MobileMenuPromoCard';
import {
  LinksColumnTitle,
  LinksContainer,
  LinksSubContainer,
  MobileMenuPrimaryLink,
  NavLink,
  SectionSubTitle,
  SectionTitle,
  TitleContainer,
} from '../mobileMenu.style';

export const GenerosityMobileMenu = () => {
  return (
    <>
      <TitleContainer>
        <SectionTitle>Generosity</SectionTitle>
        <SectionSubTitle>
          Learn about our unique generosity programs
        </SectionSubTitle>
        <MobileMenuPrimaryLink href={primaryLink.href}>
          {primaryLink.text} <PrimaryLinkArrow />
        </MobileMenuPrimaryLink>
      </TitleContainer>
      <LinksContainer>
        <LinksSubContainer>
          <LinksColumnTitle>{givingBackLinks.title}</LinksColumnTitle>
          {givingBackLinks.links.map((givingBackLink) => (
            <NavLink key={givingBackLink.text} href={givingBackLink.href}>
              {givingBackLink.text}
            </NavLink>
          ))}
        </LinksSubContainer>
        <LinksSubContainer>
          <LinksColumnTitle>{membershipLinks.title}</LinksColumnTitle>
          {membershipLinks.links.map((membershipLink) => {
            return (
              <NavLink key={membershipLink.text} href={membershipLink.href}>
                {membershipLink.text}
              </NavLink>
            );
          })}
        </LinksSubContainer>
        <MobileMenuPromoCard promoCard={promoCard} />
      </LinksContainer>
    </>
  );
};
